define('RecipesAndEvents.Facets.Model', [
    'Facets.Model',
    'SC.Configuration',
    'Utils',
    'underscore'
], function RecipesAndEventsFacetsModel(
    FacetsModel,
    Configuration,
    Utils,
    _
) {
    'use strict';

    _.extend(FacetsModel.prototype, {
        fetch: _.wrap(FacetsModel.prototype.fetch, function fetch(fn) {
            var defaultSortOption = this.getDefaultSortOption();
            if (this.options && !this.options.data) {
                this.options.data = {};
                this.options.data.custitem_item_type = 'Item';
            } else if (this.options && !this.options.data.custitem_item_type) {
                this.options.data.custitem_item_type = 'Item';
            }
            if (this.options && this.options.data && this.options.data.custitem_item_type === 'Recipe' &&
                defaultSortOption && defaultSortOption.id === this.options.data.sort) {
                this.options.data.sort = 'custitem_recipes_sort:asc';
            }
            return fn.apply(this, _.toArray(arguments).slice(1));
        }),
        getDefaultSortOption: function getDefaultSortOption() {
            var screenType = Utils.getDeviceType();
            var configSort;
            var defaultSortOption;
            if (screenType === 'phone') {
                configSort = Configuration.get('sortOptionsPhone') || [];
            } else if (screenType === 'tablet') {
                configSort = Configuration.get('sortOptionsTablet') || [];
            } else {
                configSort = Configuration.get('sortOptions') || [];
            }
            if (configSort && configSort.length) {
                defaultSortOption = _.findWhere(configSort, { isDefault: true });
            }
            return defaultSortOption;
        }
    });
});
